// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Receipt Container */
.sportsbook-bet-receipt-container {
  width: 100%; /* Full width of the viewport */
  max-width: 500px; /* Maximum width of 500px */
  position: fixed; /* Fixed positioning */
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Centering adjustment */
  z-index: 1000; /* Ensure it is on top */
  background-color: white; /* Background color */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Optional shadow */
  padding: 20px; /* Padding for content */
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 999; /* Ensure it is behind the modal but above other content */
}

/* Receipt Header */
.sportsbook-bet-receipt-header {
  width: 100%;
  height: 40px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: #f0f0f0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border: 1px solid #002129;
}

.sportsbook-bet-receipt-left-info {
  display: flex;
  align-items: center;
}

.sportsbook-bet-receipt-success-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #00aad1;
  border-radius: 50%;
  margin-right: 8px;
}

.sportsbook-bet-receipt-failure-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #CC293C;
  border-radius: 50%;
  margin-right: 8px;
}

.sportsbook-bet-receipt-circle-text {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.sportsbook-bet-receipt-text {
  color: #002129;
  font-family: "Inter", sans-serif !important;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  font-size: 12px !important;
}
@media (min-width: 600px) {
  .sportsbook-bet-receipt-text {
    font-size: 14px;
  }
}

/* Right-side info (stack the Bet Info lines) */
.sportsbook-bet-receipt-right-info {
  display: flex;
  flex-direction: column; /* Stack the two Typography elements vertically */
  justify-content: center; /* Optional: Vertically center the text */
  align-items: flex-end; /* Right-align the text */
}

.sportsbook-bet-receipt-parlay-teaser-header {
  width: 100%;
  height: 40px;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  border-bottom: 1px solid #002129;
}

.sportsbook-bet-receipt-game-info-container {
  display: flex;
  justify-content: space-between; /* Pushes the left and right content to opposite sides */
  align-items: center;
  background-color: #fff;
  width: 100%;
  margin: 0px 0px;
  height: 65px;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  border-bottom: 1px solid #002129;
}

.sportsbook-bet-receipt-game-info-container-parlay-teaser {
  display: flex;
  justify-content: space-between; /* Pushes the left and right content to opposite sides */
  align-items: center;
  background-color: #fff;
  width: 100%;
  margin: 0px 0px;
  height: 65px;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
}

.sportsbook-bet-receipt-game-info-left-side {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  margin-left: 10px;
}

.sportsbook-bet-receipt-game-info-left-text {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.sportsbook-bet-receipt-game-info-big-text {
  color: #00AAD1;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: left;
}

.sportsbook-bet-receipt-game-info-small-text {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: left;
}

.sportsbook-bet-receipt-game-info-right-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 10px;
}

.sportsbook-bet-receipt-game-info-right-text {
  text-align: right;
}

.sportsbook-bet-receipt-game-info-big-text-right {
  color: #00AAD1;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: right;
}

.sportsbook-bet-receipt-game-info-small-text-right {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: right;
  margin-top: 10px !important;
}

.sportbook-bet-receipt-circle-container {
  position: relative;
  height: 100%;
  margin-left: 10px;
  margin-right: 5px;
}

.sportsbook-bet-receipt-circle-top-line {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 50%;
  background-color: #00AAD1;
}

.sportsbook-bet-receipt-circle-bottom-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 50%;
  background-color: #00AAD1;
}

.sportsbook-bet-receipt-circle-background {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.sportsbook-bet-receipt-data-box-container {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  align-items: center;
  padding: 16px;
  border-top: 1px solid #002129;
  border-left: 1px solid #002129;
  border-right: 1px solid #002129;
  height: 35px;
  width: 100%;
}

.sportsbook-bet-receipt-data-box-text {
  color: #002129;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

.sportsbook-bet-receipt-unsuccessful-container {
  width: 100%;
  height: 40px;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  border-top: 1px solid #002129;
}

.sportsbook-bet-receipt-unsuccessful {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  text-align: center;
}

.sportsbook-bet-receipt-unsuccessful-text {
  color: #CC293C;
  font-family: "Inter", sans-serif !important;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-decoration: underline;
  font-size: 16px !important;
}
@media (min-width: 600px) {
  .sportsbook-bet-receipt-unsuccessful-text {
    font-size: 20px;
  }
}

.sportsbook-bet-receipt-done-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  height: 58px;
  border: 1px solid #002129;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.sportsbook-bet-receipt-done-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  font-size: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SportsbookComponents/BetReceipt/BetReceipt.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EACI,WAAA,EAAA,+BAAA;EACA,gBAAA,EAAA,2BAAA;EACA,eAAA,EAAA,sBAAA;EACA,QAAA,EAAA,sBAAA;EACA,SAAA,EAAA,wBAAA;EACA,gCAAA,EAAA,yBAAA;EACA,aAAA,EAAA,wBAAA;EACA,uBAAA,EAAA,qBAAA;EACA,yCAAA,EAAA,oBAAA;EACA,aAAA,EAAA,wBAAA;AACJ;;AAEA,kBAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA,EAAA,gCAAA;EACA,YAAA,EAAA,0DAAA;AACJ;;AAEA,mBAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;EACA,2CAAA;EACA,6CAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,0BAAA;AACJ;AACI;EAXJ;IAYM,eAAA;EAEJ;AACF;;AACE,+CAAA;AACF;EACI,aAAA;EACA,sBAAA,EAAA,iDAAA;EACA,uBAAA,EAAA,yCAAA;EACA,qBAAA,EAAA,yBAAA;AAEJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,+BAAA;EACA,8BAAA;EACA,gCAAA;AAAJ;;AAMA;EACI,aAAA;EACA,8BAAA,EAAA,wDAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;EACA,8BAAA;EACA,gCAAA;AAHJ;;AAMA;EACI,aAAA;EACA,8BAAA,EAAA,wDAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;AAHJ;;AAYA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AATJ;;AAYA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AATJ;;AAYA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,iBAAA;AATJ;;AAYA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,iBAAA;AATJ;;AAYA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AATJ;;AAYA;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AATJ;;AAYA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AATJ;;AAYA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;AATJ;;AAgBA;EACI,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;AAbJ;;AAgBA;EACI,cAAA;EACA,2CAAA;EACA,0BAAA;EACA,2BAAA;AAbJ;;AAoBA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;AAjBJ;;AAqBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAlBJ;;AAqBA;EACI,cAAA;EACA,2CAAA;EACA,6CAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;AAlBJ;AAoBI;EAZJ;IAaM,eAAA;EAjBJ;AACF;;AAyBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;AAtBJ;;AAyBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;AAtBJ","sourcesContent":["/* Main Receipt Container */\n.sportsbook-bet-receipt-container {\n    width: 100%; /* Full width of the viewport */\n    max-width: 500px; /* Maximum width of 500px */\n    position: fixed; /* Fixed positioning */\n    top: 50%; /* Center vertically */\n    left: 50%; /* Center horizontally */\n    transform: translate(-50%, -50%); /* Centering adjustment */\n    z-index: 1000; /* Ensure it is on top */\n    background-color: white; /* Background color */\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Optional shadow */\n    padding: 20px; /* Padding for content */\n}\n\n/* Modal Overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n    z-index: 999; /* Ensure it is behind the modal but above other content */\n}\n\n/* Receipt Header */\n.sportsbook-bet-receipt-header {\n    width: 100%;\n    height: 40px;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    background-color: #f0f0f0;  \n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n    border: 1px solid #002129;\n}\n\n.sportsbook-bet-receipt-left-info {\n    display: flex;\n    align-items: center;\n}\n\n.sportsbook-bet-receipt-success-circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    background-color: #00aad1;      // Blue background for the circle\n    border-radius: 50%;             // Makes the box a circle\n    margin-right: 8px;             // Space between the circle and text\n}\n\n.sportsbook-bet-receipt-failure-circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    background-color: #CC293C;      // Blue background for the circle\n    border-radius: 50%;             // Makes the box a circle\n    margin-right: 8px;             // Space between the circle and text\n}\n\n.sportsbook-bet-receipt-circle-text {\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.sportsbook-bet-receipt-text {\n    color: #002129;\n    font-family: 'Inter', sans-serif !important;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 26px;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    font-size: 12px !important;                 // Base font size\n  \n    @media (min-width: 600px) {\n      font-size: 14px;               // Larger font size on larger screens\n    }\n  }\n\n  /* Right-side info (stack the Bet Info lines) */\n.sportsbook-bet-receipt-right-info {\n    display: flex;\n    flex-direction: column; /* Stack the two Typography elements vertically */\n    justify-content: center; /* Optional: Vertically center the text */\n    align-items: flex-end; /* Right-align the text */\n}\n\n\n// Parlay and Teaser extra header\n.sportsbook-bet-receipt-parlay-teaser-header {\n    width: 100%;\n    height: 40px;\n    background-color: #fff;  \n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n    border-right: 1px solid #002129;\n    border-left: 1px solid #002129;\n    border-bottom: 1px solid #002129;\n}\n\n\n\n// Game Info Row Single Bets\n.sportsbook-bet-receipt-game-info-container {\n    display: flex;\n    justify-content: space-between;  /* Pushes the left and right content to opposite sides */\n    align-items: center;\n    background-color: #fff;\n    width: 100%;\n    margin: 0px 0px;\n    height: 65px;\n    border-right: 1px solid #002129;\n    border-left: 1px solid #002129;\n    border-bottom: 1px solid #002129;\n}\n\n.sportsbook-bet-receipt-game-info-container-parlay-teaser {\n    display: flex;\n    justify-content: space-between;  /* Pushes the left and right content to opposite sides */\n    align-items: center;\n    background-color: #fff;\n    width: 100%;\n    margin: 0px 0px;\n    height: 65px;\n    border-right: 1px solid #002129;\n    border-left: 1px solid #002129;\n}\n\n.sportsbook-bet-receipt-game-info-left-side {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    height: 100%; // Ensures the inner Box takes the full height of the outer Box\n    margin-left: 10px;\n\n    // svg {\n    //     width: 18px;\n    //     height: 18px;\n    //     fill: #CC293C;\n    // }\n}\n\n.sportsbook-bet-receipt-game-info-left-text {\n    display: flex;\n    flex-direction: column;\n    margin-left: 12px; // Space between the icon and the text\n}\n\n.sportsbook-bet-receipt-game-info-big-text {\n    color: #00AAD1;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: left;\n}\n\n.sportsbook-bet-receipt-game-info-small-text {\n    color: #002129;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 10px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: left;\n}\n\n.sportsbook-bet-receipt-game-info-right-side {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;  // Right align the content\n    margin-right: 10px;\n}\n\n.sportsbook-bet-receipt-game-info-right-text {\n    text-align: right;  // Ensure text within the box is right-aligned\n}\n\n.sportsbook-bet-receipt-game-info-big-text-right {\n    color: #00AAD1;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: right;\n}\n\n.sportsbook-bet-receipt-game-info-small-text-right {\n    color: #002129;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 10px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: right;\n    margin-top: 10px !important;\n}\n\n.sportbook-bet-receipt-circle-container {\n    position: relative;\n    height: 100%;\n    margin-left: 10px;\n    margin-right: 5px;\n}\n\n.sportsbook-bet-receipt-circle-top-line {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 2px;\n    height: 50%;\n    background-color: #00AAD1;\n}\n\n.sportsbook-bet-receipt-circle-bottom-line {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 2px;\n    height: 50%;\n    background-color: #00AAD1;\n}\n\n.sportsbook-bet-receipt-circle-background {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n}\n\n\n\n\n// Bet Receipt Data Box (Bet Amount, To Win, Payout)\n.sportsbook-bet-receipt-data-box-container {\n    display: flex;\n    justify-content: space-between;\n    background-color: #fff;\n    align-items: center;\n    padding: 16px;\n    border-top: 1px solid #002129;\n    border-left: 1px solid #002129;\n    border-right: 1px solid #002129;\n    height: 35px;\n    width: 100%;\n}\n\n.sportsbook-bet-receipt-data-box-text {\n    color: #002129;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 12px !important;\n    font-weight: 700 !important;\n}\n\n\n\n\n// Unsuccesful Bet Message\n.sportsbook-bet-receipt-unsuccessful-container {\n    width: 100%;\n    height: 40px;\n    background-color: #fff;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;  // Center the content horizontally\n    padding: 0 16px;\n    border-right: 1px solid #002129;\n    border-left: 1px solid #002129;\n    border-top: 1px solid #002129;\n}\n\n\n.sportsbook-bet-receipt-unsuccessful {\n    display: flex;\n    flex-direction: column;\n    align-items: center;  // Center the content horizontally\n    justify-content: center;  // Center the content vertically\n    background-color: #fff;\n    text-align: center;\n}\n\n.sportsbook-bet-receipt-unsuccessful-text {\n    color: #CC293C;\n    font-family: 'Inter', sans-serif !important;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 26px;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-decoration: underline;\n    font-size: 16px !important;                 // Base font size\n  \n    @media (min-width: 600px) {\n      font-size: 20px;               // Larger font size on larger screens\n    }\n  }\n\n\n\n\n\n// Done Button\n.sportsbook-bet-receipt-done-button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #fff;\n    height: 58px;\n    border: 1px solid #002129;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n.sportsbook-bet-receipt-done-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 42px;\n    font-size: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
